<template>
  <v-list-item>
    <v-list-item-content>
      <v-container grid-list-md>
        <v-layout align-baseline>
          <v-flex sm1>
            <v-icon
              @click="onCheck"
              :color="rateItem.checked ? 'success':'grey lighten-3'"
              large
            >mdi-check</v-icon>
          </v-flex>
          <v-flex sm1 class="text-xs-left">{{rateItem.serviceName}}</v-flex>
          <v-flex sm1>
            <v-select
              v-if="showEdits"
              :items="rateTypes"
              v-model="rateItem.rateTypeCode"
              label="Rate Type"
              item-text="name"
              item-value="code"
            >
              <template slot="selection" slot-scope="data">{{data.item.code}}</template>
            </v-select>
            <span v-else>{{rateItem.rateTypeCode}}</span>
          </v-flex>
          <v-flex sm1>
            <v-text-field
              label="Cost"
              v-model.number="rateItem.adultBuy1"
              type="number"
              min="0"
              @change="onAdultBuyChange"
            ></v-text-field>
          </v-flex>
          <v-flex sm1>
            <currency-list-select
              v-if="showEdits"
              customLabel="Cost-Curr"
              :currencyCode="rateItem.currencyCodeBuy"
              :showCodeAsName="true"
              @onSelect="onCurrencyBuySelect"
            ></currency-list-select>
            <span v-else>{{rateItem.currencyCodeBuy}}</span>
          </v-flex>
          <v-flex sm1>
            <v-text-field
              label="Markup"
              v-model.number="rateItem.markup"
              type="number"
              min="0"
              @change="onMarkupChange"
            ></v-text-field>
          </v-flex>
          <v-flex sm1>
            <v-text-field
              label="Sell"
              v-model.number="rateItem.adultSell1"
              type="number"
              min="0"
              @change="onAdultSellChange"
            ></v-text-field>
          </v-flex>
          <v-flex sm1>
            <currency-list-select
              v-if="showEdits"
              custom-label="Sell-Curr"
              :currencyCode="rateItem.currencyCodeSell"
              :showCodeAsName="true"
              @onSelect="onCurrencySellSelect"
            ></currency-list-select>
            <span v-else>{{rateItem.currencyCodeSell}}</span>
          </v-flex>
          <v-flex sm1>
            <v-text-field label="Min Stay" v-model.number="rateItem.minStay" type="number" min="0"></v-text-field>
          </v-flex>
          <v-flex sm1>
            <v-text-field label="Max Stay" v-model.number="rateItem.maxStay" type="number" min="0"></v-text-field>
          </v-flex>
          <v-flex sm1>
            <v-text-field label="Rate Plan" v-model="rateItem.ratePlan"></v-text-field>
          </v-flex>
          <v-flex sm1>
            <v-btn icon class="ml-4" v-show="rateItem.checked" @click="editItem">
              <v-icon color="teal">mdi-pencil</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import CurrencyListSelect from "../../../shared/CurrencyListSelect";
import { priceProperties } from "../edit/price-details/price-properties";

export default {
  name: "SupplierRatesListItem",

  components: {
    CurrencyListSelect
  },

  props: {
    value: {
      type: Object,
      default: () => {}
    },
    rateTypes: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      rateItem: {
        id: this.value.id,
        serviceId: this.value.serviceId,
        serviceName: this.value.serviceName,
        rateTypeCode: this.value.rateTypeCode,
        adultBuy1: (0.0).toFixed(2),
        adultSell1: (0.0).toFixed(2),
        dateFrom: this.value.dateFrom,
        dateTo: this.value.dateTo,
        currencyCodeBuy: this.value.currencyCodeBuy,
        currencyCodeSell: this.value.currencyCodeSell,
        minStay: 0,
        maxStay: 0,
        groupId: this.value.groupId,
        seasonId: this.value.seasonId,
        ratePlan: this.value.ratePlan,
        markup: this.value.markup,
        checked: false
      }
    };
  },
  computed: {
    showEdits() {
      return this.rateItem.checked;
    },
    validRateItem() {
      return {
        ...this.rateItem,
        adultBuy1: Number(this.rateItem.adultBuy1),
        adultSell1: Number(this.rateItem.adultSell1)
      };
    }
  },
  methods: {
    onCheck(event) {
      this.rateItem.checked = !this.rateItem.checked;
      this.$emit("input", this.validRateItem);
    },
    onAdultBuyChange(event) {
      if (!isNaN(parseFloat(event))) {
        //update sell
        if (this.rateItem.markup > 0) {
          this.rateItem.adultSell1 = (
            Number(event) +
            Number(event) * (Number(this.rateItem.markup) / 100)
          ).toFixed(2);
          this.updateDayOfWeekPrices("adultSell");
        }
        //format
        this.rateItem.adultBuy1 = parseFloat(event).toFixed(2);
      } else {
        this.rateItem.adultBuy1 = (0.0).toFixed(2);
      }
      this.updateDayOfWeekPrices("adultBuy");
      this.onChange();
    },
    onMarkupChange(event) {
      if (!isNaN(parseFloat(event))) {
        const markup = Number(event);
        if (markup > 0) {
          const cost = parseInt(this.rateItem.adultBuy1);
          this.rateItem.adultSell1 = (cost + cost * (markup / 100)).toFixed(2);
          this.updateDayOfWeekPrices("adultSell");
        }
      } else {
        this.rateItem.markup = 0;
      }
      this.onChange();
    },
    onAdultSellChange(event) {
      if (!isNaN(parseFloat(event))) {
        this.rateItem.adultSell1 = parseFloat(event).toFixed(2);
        this.rateItem.markup = (
          ((Number(this.rateItem.adultSell1) -
            Number(this.rateItem.adultBuy1)) /
            Number(this.rateItem.adultBuy1)) *
          100
        ).toFixed(2);
      } else {
        this.rateItem.adultSell1 = (0).toFixed(2);
      }
      this.updateDayOfWeekPrices("adultSell");
      this.onChange();
    },
    onCurrencyBuySelect(data) {
      this.rateItem.currencyCodeBuy = data;
      this.onChange();
    },
    onCurrencySellSelect(data) {
      this.rateItem.currencyCodeSell = data;
      this.onChange();
    },
    onChange() {
      this.rateItem.checked = true;
      this.$emit("input", this.validRateItem);
    },
    editItem() {
      this.$emit("edit", this.validRateItem);
    },
    updateDayOfWeekPrices(fieldName) {
      for (let i = 2; i <= 7; i++) {
        this.rateItem[`${fieldName}${i}`] = this.rateItem[`${fieldName}1`];
      }
    }
  },

  watch: {
    value(newVal) {
      for (let prop in priceProperties) {
        const value = newVal[prop] ? newVal[prop] : priceProperties[prop];
        this.rateItem[prop] =
          prop === "adultBuy1" || prop === "adultSell1"
            ? Number(value).toFixed(2)
            : value;
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/supplier-rates/add/SupplierRatesAddListItem.vue